module.exports = __webpack_public_path__ + "static/img/app_online_income.65bca12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_online_income.png
// module id = fr5S
// module chunks = 8